import {Payment} from "../../models/license";
import {WebClient} from "../../store/clients/client";
import {
    CheckoutSession,
    CheckoutSessionResponse,
    RefundPayment,
    RefundPaymentResponse,
    VerifyPaymentBody, VerifyPaymentResponse
} from "../../models/checkout";

// ---------------------------------------- ADMIN ----------------------------------------
export async function adminGetPaymentsPaginated(page:number): Promise<Payment[]> {
    try {
        const response = await WebClient.AdminGetPaymentsPaginated(page);

        if (response.status === 200) {
            return response.data["results"] as Payment[];
        }
    }catch (e) {}

    return [] as Payment[];
}

export async function adminRefundPayment(refundPayment: RefundPayment): Promise<RefundPaymentResponse> {
    try {
        const response = await WebClient.AdminRefundPayment(refundPayment);

        if (response.status === 200) {
            return response.data as RefundPaymentResponse;
        } else {
            // Log error details for debugging
            console.error('Refund payment failed:', response);
            const errorMessage = response.data?.error || `Server returned status ${response.status}`;
            throw new Error(errorMessage);
        }
    } catch (e: any) {
        // Re-throw if it's already an Error, otherwise wrap it
        if (e instanceof Error) {
            throw e;
        }
        throw new Error(e?.message || 'Failed to process refund');
    }
}

// ---------------------------------------- USER ----------------------------------------
export async function createCheckoutSession(checkoutSession: CheckoutSession): Promise<CheckoutSessionResponse> {
    try {
        const response = await WebClient.CreateCheckoutSession(checkoutSession);

        if (response.status === 200) {
            return response.data as CheckoutSessionResponse;
        } else {
            // Log error details for debugging
            console.error('Checkout session creation failed:', response);
            const errorMessage = response.data?.error || `Server returned status ${response.status}`;
            throw new Error(errorMessage);
        }
    } catch (e: any) {
        // Re-throw if it's already an Error, otherwise wrap it
        if (e instanceof Error) {
            throw e;
        }
        throw new Error(e?.message || 'Failed to create checkout session');
    }
}

export async function verifyPayment(verifyPaymentBody: VerifyPaymentBody): Promise<VerifyPaymentResponse> {
    try {
        const response = await WebClient.VerifyPayment(verifyPaymentBody);

        if (response.status === 200) {
            return response.data as VerifyPaymentResponse;
        }
    }catch (e) {}

    return {} as VerifyPaymentResponse;
}

// export async function getStripeWebhook(verifyPaymentBody: VerifyPaymentBody): Promise<VerifyPaymentResponse> {
//     try {
//         const response = await WebClient.VerifyPayment(verifyPaymentBody);
//
//         if (response.status === 200) {
//             return response.data as VerifyPaymentResponse;
//         }
//     }catch (e) {}
//
//     return {} as VerifyPaymentResponse;
// }

